/**
 * The next two hours, in one snapshot.
 *
 * The types are the endpoint's records as the generated schema publishes them
 * (`src/Taxi.Modules.Dispatch/Domain/Timeline.cs`), under the names the view uses.
 */

import { request, type Schema } from '@taxi/api-client';

/** What a driver is on, and when they come free. */
export type TimelineJob = Schema<'TimelineJob'>;

/** An offer out with a driver, and how long they have left to answer. */
export type TimelineOffer = Schema<'TimelineOffer'>;

export type TimelineDriver = Schema<'TimelineDriver'>;

export type TimelineOrder = Schema<'TimelineOrder'>;

export type TimelineBooking = Schema<'TimelineBooking'>;

export type TimelineTotals = Schema<'TimelineTotals'>;

export type TimelineSnapshot = Schema<'TimelineSnapshot'>;

export const timelineApi = {
  snapshot: () => request<TimelineSnapshot>('/api/dispatch/timeline'),
};
